import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    gap: 10px;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    height: 80%;

    @media (max-width: 700px) {
        gap: 15px;
    }
`;

export const ContaintableButton = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

export const Table = styled.table`
    width: 100%;
    height: 100%;
    border-collapse: collapse;
    font-size: 14px;
    
    th:last-child,
    td:last-child{
        width: 85px;
    }

    th:nth-child(1),
    td:nth-child(1),
    th:nth-child(2),
    td:nth-child(2) {
        width: 50px;
    }
    
    td,
    th {
        text-align: center;
        padding: 10px 0;
    }

    & svg {
        font-size: 18px;
    }

    @media (max-width: 900px) {
        th, td {
            display: none;
        }

        th:nth-child(1),
        td:nth-child(1), /* Primeira coluna */
        th:nth-child(2),
        td:nth-child(2),
        th:nth-child(3), /* Segunda coluna */
        td:nth-child(3), /* Segunda coluna */
        th:last-child,
        td:last-child { /* Ultima coluna */
            display: table-cell;
        }
    }
`;

export const THead = styled.thead`
    background-color: ${(props) => props.theme.colors.gray.gray_50};
`;

export const TBody = styled.tbody`
    display: block;
    overflow-y: auto;
    width: 100%;
    height: 100%;

    &::-webkit-scrollbar { 
        display: none;
    }
`;

export const Tr = styled.tr`
    display: table;
    width: 100%;
    table-layout: fixed;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_50};

    &:hover{
        background-color: ${(props) => props.theme.colors.gray.gray_50};
    }
`;

export const Td = styled.td``;

export const ContentField = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
`;

export const HighlightedField = styled.p`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    background-color: ${(props) => props.theme.colors.red.red_50};
    border-radius: 4px;
    padding: 3px 5px;
    font-size: 12px;
    
    &.active {
        color: ${(props) => props.theme.colors.success};
        border: 1px solid ${(props) => props.theme.colors.success};
    }
    
    &.inactive {
        color: ${(props) => props.theme.colors.error};
        border: 1px solid ${(props) => props.theme.colors.error};
    }
    
    &.scheduled {
        color: ${(props) => props.theme.colors.warning};
        border: 1px solid ${(props) => props.theme.colors.warning};
    }
    
    &.purple {
        color: ${(props) => props.theme.colors.purple};
        border: 1px solid ${(props) => props.theme.colors.purple};
    }
    
    &.blue {
        color: ${(props) => props.theme.colors.blue};
        border: 1px solid ${(props) => props.theme.colors.blue};
    }

`;

export const ButtonTable = styled.button`
    display: flex;
    justify-content: center;

    padding: 8px;
    
    border-radius: 30px;
    box-shadow: 0px 1px 4px 0px ${(props) => props.theme.colors.gray.gray_100};
    background-color: ${(props) => props.theme.colors.white};
    
    &:hover {
        background-color: ${(props) => props.theme.colors.gray.gray_100};
    }
`;

export const CheckBox = styled.input`
  width: 18px;
  height: 18px;
  appearance: none;
  cursor: pointer;

  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.colors.gray.gray_100};

  &:checked {
    background-color: ${(props) => props.theme.colors.primary};
    border-color: ${(props) => props.theme.colors.primary}; /* Borda ao marcar */
  }

  &:hover {
    border-color:${(props) => props.theme.colors.primary}; /* Cor ao passar o mouse */
  }

  &::after {
    content: '';
    display: block;
    width: 8px;
    height: 8px;
    margin: 3px auto;
    color: ${(props) => props.theme.colors.white};
    opacity: 0;
    transition: opacity 0.2s ease;
  }
`;

export const ContentButton = styled.div`
    padding: 4px 0px;
`;

export const ButtonDelete = styled.button`
    display: flex;
    box-shadow: 0px 1px 4px 0px ${(props) => props.theme.colors.gray.gray_100};
    background-color: transparent;
    color: ${(props) => props.theme.colors.error};
    padding: 4px 10px;
    border-radius: 30px;

    &:hover{
        background-color: ${(props) => props.theme.colors.gray.gray_50};
    }
`;

export const UserProfile = styled.div`
    display: flex;
    background-color: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.gray.gray_800};
    padding: 10px;
    border-radius: 50%;
    box-shadow: 0px 4px 4px 0px ${(props) => props.theme.colors.gray.gray_100};
    font-weight: 600;
    border: 1px solid ${(props) => props.theme.colors.gray.gray_50};
`;

//Pop Menu Table
export const TdPopMenu = styled.td`
    text-align: start;
    position: relative;
`;

export const ContentPopMenu = styled.div`
    display: flex;
    justify-content: center;
`;

export const PopMenu = styled.div`
    position: absolute;
    right: 0;
    top: 60%;
    z-index: 10;
    background-color: white;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    min-width: 150px; /* Defina o tamanho mínimo do menu */
    
    /* Adicione isso se quiser que o menu apareça acima em vez de abaixo quando próximo ao final da tabela */
    &.top-position {
        top: auto;
        bottom: 100%;
    }  
`;